const MAX_SIZE_BYTES = 5 * 1024 * 1024; // 5 MB

const MAGIC_BYTES = [
  { mime: 'image/jpeg', bytes: [0xFF, 0xD8, 0xFF] },
  { mime: 'image/png',  bytes: [0x89, 0x50, 0x4E, 0x47] },
  { mime: 'image/gif',  bytes: [0x47, 0x49, 0x46, 0x38] },
  { mime: 'image/webp', bytes: [0x52, 0x49, 0x46, 0x46], offset: 0, extraCheck: true },
];

function readHeader(file, length) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(new Uint8Array(reader.result));
    reader.readAsArrayBuffer(file.slice(0, length));
  });
}

function matchesMagic(bytes, magic) {
  return magic.bytes.every((b, i) => bytes[i] === b);
}

async function checkMagicBytes(file) {
  const header = await readHeader(file, 12);

  for (const magic of MAGIC_BYTES) {
    if (!matchesMagic(header, magic)) continue;
    // WebP: bytes 8-11 must be 'WEBP'
    if (magic.extraCheck) {
      const webp = [0x57, 0x45, 0x42, 0x50];
      if (!webp.every((b, i) => header[8 + i] === b)) continue;
    }
    return magic.mime;
  }
  return null;
}

/**
 * Validates an image File before upload.
 * Returns { valid: true, mime } or { valid: false, error: string }.
 */
export async function validateImage(file) {
  if (!file) return { valid: false, error: 'No file selected.' };

  if (file.size > MAX_SIZE_BYTES) {
    return { valid: false, error: 'Image must be 5 MB or smaller.' };
  }

  const allowed = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
  if (!allowed.includes(file.type)) {
    return { valid: false, error: 'Only JPEG, PNG, GIF, or WebP images are allowed.' };
  }

  const detectedMime = await checkMagicBytes(file);
  if (!detectedMime) {
    return { valid: false, error: 'File does not appear to be a valid image.' };
  }

  return { valid: true, mime: detectedMime };
}
